// ClimatologyAdjustmentsForm.jsx
import React from 'react'
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Climatology Adjustments form
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function ClimatologyAdjustmentsForm({model, setModel}) {
  // When there is a change to an input element, modify the model.
  const updateValue = (val, type, position) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''
    if(model && model.ADJUSTMENTS && model.ADJUSTMENTS.MONTHLY){
      let newAdj = model.ADJUSTMENTS.MONTHLY[type]
      newAdj[position] = val

      setModel(prev => ({
        ...prev,
        ADJUSTMENTS:{
          ...prev.ADJUSTMENTS,
          MONTHLY: {
            ...prev.ADJUSTMENTS.MONTHLY,
            [type]: newAdj
          }
        }
      }))
    }
  }

  // Descriptive text and names of parameters
  const UIParams = [
    {uiText: 'Jan'},
    {uiText: 'Feb'},
    {uiText: 'Mar'},
    {uiText: 'Apr'},
    {uiText: 'May'},
    {uiText: 'Jun'},
    {uiText: 'Jul'},
    {uiText: 'Aug'},
    {uiText: 'Sep'},
    {uiText: 'Oct'},
    {uiText: 'Nov'},
    {uiText: 'Dec'},
  ]

  return(
    <>
    {
      model.ADJUSTMENTS &&
      model.ADJUSTMENTS.MONTHLY &&
      <>
      <Grid container style={{fontSize: '12px'}}>
        <Grid container >
          <Grid item xs={3}>
            <div style={{borderBottom:'3px solid #fff'}}>Month</div>
          </Grid>
          <Grid item xs={2}>
            <div style={{borderBottom:'3px solid #fff'}}>Temp</div>
          </Grid>
          <Grid item xs={2}>
            <div style={{borderBottom:'3px solid #fff'}}>Evap</div>
          </Grid>
          <Grid item xs={2}>
            <div style={{borderBottom:'3px solid #fff'}}>Rain</div>
          </Grid>
          <Grid item xs={2}>
            <div style={{borderBottom:'3px solid #fff'}}>Cond</div>
          </Grid>
        </Grid>
        {
        UIParams.map((v, i)=>{
          return (
            <React.Fragment key={'ClimatologyAdj'+i}>
              <Grid container >
                <Grid item xs={3} style={{fontSize: '10px'}}>
                  {
                    <label  style={{height: '22px'}}
                            className='editor-small'
                    >{v.uiText}</label>
                  }
                </Grid>
                <Grid item xs={2}>
                  {
                    <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'TEMPERATURE', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.TEMPERATURE[i]}
                      id={'ClimatologyAdjTemp'+i.toString()}
                    />
                  }
                </Grid>
                <Grid item xs={2}>
                  {
                    <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'EVAPORATION', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.EVAPORATION[i]}
                      id={'ClimatologyAdjEvap'+i.toString()}
                    />
                  }
                </Grid>
                <Grid item xs={2}>
                  {
                    <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'RAINFALL', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.RAINFALL[i]}
                      id={'ClimatologyAdjRain'+i.toString()}
                    />
                  }
                </Grid>
                <Grid item xs={2}>
                  {
                    <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'CONDUCTIVITY', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.CONDUCTIVITY[i]}
                      id={'ClimatologyAdjCond'+i.toString()}
                    />
                  }
                </Grid>
              </Grid>
            </React.Fragment>
          )
        })
        }
      </Grid>
      {/*<>
      <Grid container>
        <Grid item xs={3}>
          <div style={{borderBottom:'3px solid #fff'}}>Month</div>
          <label className='editor-small' >Jan</label>
          <label className='editor-small' >Feb</label>
          <label className='editor-small' >Mar</label>
          <label className='editor-small' >Apr</label>
          <label className='editor-small' >May</label>
          <label className='editor-small' >Jun</label>
          <label className='editor-small' >Jul</label>
          <label className='editor-small' >Aug</label>
          <label className='editor-small' >Sep</label>
          <label className='editor-small' >Oct</label>
          <label className='editor-small' >Nov</label>
          <label className='editor-small' >Dec</label>
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Temp</div>
          {
            UIParams.map((v, i)=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'TEMPERATURE', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.TEMPERATURE[i]}
                      id={'ClimatologyAdjTemp'+i.toString()}
                      key={'ClimatologyAdjTemp'+i.toString()}
              />
            )
          }
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Evap</div>
          {
            UIParams.map((v, i)=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'EVAPORATION', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.EVAPORATION[i]}
                      id={'ClimatologyAdjEvap'+i.toString()}
                      key={'ClimatologyAdjEvap'+i.toString()}
              />
            )
          }
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Rain</div>
          {
            UIParams.map((v, i)=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'RAINFALL', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.RAINFALL[i]}
                      id={'ClimatologyAdjRain'+i.toString()}
                      key={'ClimatologyAdjRain'+i.toString()}
              />
            )
          }
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Cond</div>
          {
            UIParams.map((v, i)=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, 'CONDUCTIVITY', i)}}
                      value={model.ADJUSTMENTS.MONTHLY.CONDUCTIVITY[i]}
                      id={'ClimatologyAdjCond'+i.toString()}
                      key={'ClimatologyAdjCond'+i.toString()}
              />
            )
          }
        </Grid>
      </Grid>
        </>*/}</>
    }
    </>
  )
}